import { createSelector } from 'reselect';

export const initialisedSelector = createSelector(
  state => state.app.initialised,
  initialised => initialised
);

export const loadingSelector = createSelector(
  state => state.app.loading,
  loading => loading
);

export const genreSelector = createSelector(
  state => state.app.data.groups,
  state => state.bikes.genreCards,
  (genres, featureCards) =>
    genres.map(genre => ({
      ...genre,
      cards: featureCards[genre.id],
    }))
);

export const labelsSelector = createSelector(
  state => state.app.data.labels,
  labels => labels
);

export const heroSelector = createSelector(
  state => state.app.data.hero.heroTitle,
  state => state.app.data.hero.heroImage,
  (title, image) => ({ title, image })
);

export const basepathSelector = createSelector(
  state => state.app.basepath,
  basepath => {
    if (basepath && basepath[basepath.length - 1] === '/') {
      basepath = basepath.substr(0, basepath.length - 1); // eslint-disable-line
    }

    return basepath;
  }
);

export const breadcrumbSelector = createSelector(
  state => state.app.breadcrumb,
  breadcrumb => breadcrumb
);

export const disclaimerSelector = createSelector(
  state => state.app.data.disclaimers,
  disclaimer => disclaimer
);

export const showPriceDisclaimerSelector = createSelector(
  state => state.app.data.showPriceDisclaimer,
  showPriceDisclaimer => showPriceDisclaimer
);

export const ctaSelector = createSelector(
  state => state.app.data.ctas,
  cta => cta
);

export const lastPageSelector = createSelector(
  state => state.app.history,
  pages => pages[pages.length - 2]
);

export const currencyCodeSelector = createSelector(
  state => state.app.data.currency,
  currencyCode => currencyCode
);

export const pdfLogoSelector = createSelector(
  state => state.app.data.pdfLogo,
  pdfLogo => pdfLogo
);

export const filtersSelector = createSelector(
  state => state.app.data.filters,
  filters => filters
);

export const getErrorSelector = createSelector(
  state => state.app.error,
  error => error
);

export const getSendToDealerData = createSelector(
  state => state.app.data.sendToDealer,
  sendToDealer => sendToDealer
);

export const getIcons = createSelector(
  state => state.app.icons,
  labels => labels
);

export const lgpdSelector = createSelector(
  state => state.app.data.lgpd,
  lgpd => lgpd
);

export const getGoalId = goal =>
  createSelector(
    state => state.app.data.goals[goal],
    goalId => goalId
  );

export const getLabels = createSelector(
  state => state.app.data.labels,
  labels => labels
);

export const getProvinces = createSelector(
  state => state.app.data.provinces?.provinces || [],
  provinces => provinces
);

export const getProvincePricingEnabled = createSelector(
  state => state.app.data.provinces?.useProvincePricing || false,
  provincePricingEnabled => provincePricingEnabled
);
